import { brandPrimaryHover, titles } from '../../../../web/styles/colors';
import { CssSelectors, baseStyleSheet } from '../../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		paddingTop: 60,
	},
	footer: {
		display: 'flex',
		...CssSelectors.allDescendants(
			{
				marginRight: 10,
			},
			'button:first-child'
		),
		...CssSelectors.allDescendants(
			{
				color: brandPrimaryHover,
			},
			'button:nth-child(2)'
		),
	},
	heading: {
		color: brandPrimaryHover,
		fontSize: 18,
		margin: '0 0 12px',
	},
	paragraph: {
		color: titles,
		fontSize: 14,
		margin: '0 0 28px',
		maxWidth: 255,
	},
	strong: {
		...baseStyleSheet.fontBold,
	},
});
